import { api } from 'data/api/api'
import { moneyObjectHeader } from 'data/api/money-object-header'

import { GetNearbyPickupPointsArgs, NearbyPickupPointsResp } from '../types/nearby-pickup-points'
import { CountryBoundsResponse } from '../types/country-bounds'
import { getNearbyPickupPointsArgsToParams } from '../transformers/nearby-pickup-points'

export const getNearbyPickupPoints = (args: GetNearbyPickupPointsArgs) =>
  api.get<NearbyPickupPointsResp>(`/shipping_orders/${args.shippingOrderId}/nearby_pickup_points`, {
    params: getNearbyPickupPointsArgsToParams(args),
    headers: moneyObjectHeader,
  })

export const getCountryBounds = (countryId: number) =>
  api.get<CountryBoundsResponse>(`/countries/${countryId}/bounds`)
